<!-- mb-6, not mb-4: Bootstrap's !important mb-4 was what actually rendered here (24px), and
     Tailwind's mb-6 is the same 24px without depending on Bootstrap. -->
<div class="shrink-0" [ngClass]="flush ? '' : 'mb-6'">
  <div class="flex items-start gap-2">
    <div class="flex min-w-0 flex-1 flex-wrap items-center gap-x-4 gap-y-2">
      <!-- `attr.id`, not `id`: a property binding of null still leaves an empty id="" behind, and
           an empty id is a valid `aria-labelledby` target that resolves to nothing. -->
      <h2 [attr.id]="titleId || null" class="m-0 min-w-0 text-xl font-medium">
        {{ title }}
      </h2>

      <!-- Controls that belong to the title - a section switcher, a status - sit right beside it,
           so it reads as part of the heading rather than as a far-off action. -->
      <ng-content select="[dialogHeaderLead]"></ng-content>
    </div>

    <!-- Header-level actions (an export button, a help link) sit left of the close. Projected
         children are flex items of this row, so the gap above spaces them without a global
         rule keyed on the slot attribute. -->
    <ng-content select="[dialogHeaderActions]"></ng-content>

    <button
      *ngIf="showClose"
      mat-icon-button
      type="button"
      class="-mr-2 -mt-1 shrink-0"
      [disabled]="closeDisabled"
      [attr.aria-label]="closeLabel"
      [matTooltip]="closeLabel"
      (click)="closed.emit()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <p *ngIf="subtitle" class="m-0 mt-1 text-sm text-gray-500">{{ subtitle }}</p>

  <mat-divider *ngIf="divider" class="mt-3"></mat-divider>
</div>
